export function isFinanceTempAuditRole(auditRole) {
  return String(auditRole || '').startsWith('finance-temp');
}

export function isFinanceTempAccountUser(user) {
  return isFinanceTempAuditRole(user?.auditRole)
    || isFinanceTempAuditRole(user?.tempScopeConfig?.meta?.roleHint);
}

export function filterUsersBySearch(users = [], searchTerm = '') {
  const keyword = String(searchTerm || '').toLowerCase();
  if (!keyword) return Array.isArray(users) ? users : [];
  return (Array.isArray(users) ? users : []).filter((user) => {
    const username = String(user?.username || '').toLowerCase();
    const name = String(user?.name || '').toLowerCase();
    const email = String(user?.email || '').toLowerCase();
    return username.includes(keyword) || name.includes(keyword) || email.includes(keyword);
  });
}

export function splitUsersByFinanceTemp(users = []) {
  const tempUsers = [];
  const normalUsers = [];
  (Array.isArray(users) ? users : []).forEach((user) => {
    if (isFinanceTempAccountUser(user)) tempUsers.push(user);
    else normalUsers.push(user);
  });
  return { tempUsers, normalUsers };
}
